let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lY0zh")).then(() => parcelRequire('bvNzF'));